import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { inject } from 'mobx-react';
import { Page } from '../common';

import SessionStoreClass from '../../stores/SessionStoreClass';

interface IProps {
  SessionStore?: SessionStoreClass;
}

class CubeAnalyticsPage extends Component<IProps> {
  get cubeAnalyticsUrl () {
    // @ts-ignore: Mighty is injected as a global in Funsoft's HTML shell.
    const cubeAnalyticsBaseUrl = window.Mighty.CUBE_ANALYTICS_URL;

    if (!cubeAnalyticsBaseUrl || cubeAnalyticsBaseUrl === 'undefined') {
      return '';
    }

    try {
      const url = new URL(cubeAnalyticsBaseUrl);
      url.pathname = `${url.pathname.replace(/\/+$/, '')}/`;

      const impersonatedUserId = this.props.SessionStore?.impersonatedUserId;
      if (impersonatedUserId) {
        url.searchParams.set('impersonated_user_id', impersonatedUserId);
      }

      return url.toString();
    }
    catch (error) {
      return '';
    }
  }

  // tslint:disable-next-line:member-access
  render () {
    const cubeAnalyticsUrl = this.cubeAnalyticsUrl;

    return (
      <Page name='cube-analytics' type='list'>
        <Helmet title='Analytics' />
        <Page.Content>
          {!cubeAnalyticsUrl && <div className='page-error'>Cube Analytics is not configured.</div>}
          {cubeAnalyticsUrl && <iframe className='fullscreen' frameBorder='0' src={cubeAnalyticsUrl} />}
        </Page.Content>
      </Page>
    );
  }
}

export default inject('SessionStore')(CubeAnalyticsPage);
